module.exports = __webpack_public_path__ + "media/22.02abbac7.mp3";